import React__default, { useRef } from 'react';
import PT from 'prop-types';
import { T as TooltipScrollContainer, P as PopperContent, F as FlexContainer, C as ChildrenWrapper, a as CloseButton, b as CloseIcon } from './PopperContentContainer.styles-lkgy0VEd.js';
import { P as PortalComponent } from '../../Portal/PortalComponent-hgGe6gzl.js';
import { P as PortalContextProvider } from '../../Portal/PortalContext-C2W72KMF.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { t as times } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

const PopperContentContainer = ({
  children,
  closeButtonLabel,
  handleCloseClicked,
  footer,
  padding,
  type = 'light',
  withCloseButton
}) => {
  const portalRef = useRef(null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TooltipScrollContainer, null, /*#__PURE__*/React__default.createElement(PortalContextProvider, {
    portalElementRef: portalRef
  }, /*#__PURE__*/React__default.createElement(PopperContent, {
    $padding: padding
  }, /*#__PURE__*/React__default.createElement(FlexContainer, null, /*#__PURE__*/React__default.createElement(ChildrenWrapper, null, children), withCloseButton && /*#__PURE__*/React__default.createElement(CloseButton, {
    "aria-label": closeButtonLabel,
    onClick: handleCloseClicked,
    $styleType: type,
    type: "button",
    taktFallbackId: createStormTaktId('close-button')
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    type: times
  }))), footer && /*#__PURE__*/React__default.createElement(FlexContainer, null, footer)))), /*#__PURE__*/React__default.createElement(PortalComponent, {
    ref: portalRef
  }));
};
PopperContentContainer.propTypes = {
  handleCloseClicked: PT.func.isRequired,
  children: PT.node,
  closeButtonLabel: PT.string,
  footer: PT.node,
  padding: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  type: PT.oneOf(['light', 'dark', 'blue']),
  withCloseButton: PT.bool
};
PopperContentContainer.defaultProps = {
  children: undefined,
  closeButtonLabel: 'Close Tooltip',
  footer: undefined,
  padding: 'base',
  type: 'light',
  withCloseButton: true
};

export { PopperContentContainer as P };
//# sourceMappingURL=PopperContentContainer-B3VjPTlg.js.map
